/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/useAuth";
import { isArrayNotEmpty } from "cms/utils/empty-exists";
import { useSimpliCity } from "@simplicitycms/simplicity-common";
import { SimpliCitySDK } from "cms/sdk";
import { NavCardsSimpleSectionItem } from "./nav-cards-simple-section-item";

const NavCardsSimpleComponent = () => {
    // const component = props?.component;
    const { token } = useAuth();
    const { webpage } = useSimpliCity();
    const webpage_guid = webpage?.guid;

    const [children, setChildren] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const executeAsync = async () => {
            if (!webpage_guid) {
                setLoading(false);
                return;
            }

            try {
                // Fetch webpage children directly using the SDK
                const response = await SimpliCitySDK.webpage.findChildren(token, webpage_guid);
                const children = response?.children || [];

                if (children && children.length > 0) {
                    const enhancedChildren = await Promise.all(
                        children.map(async (child) => {
                            try {
                                const childGuid = child?.guid;
                                const banner_image = await SimpliCitySDK.webpage.getWebpageBannerImage(token, childGuid);

                                return {
                                    ...child,
                                    banner_image: banner_image || null
                                };
                            } catch (error) {
                                return {
                                    ...child,
                                    banner_image: null
                                };
                            }
                        })
                    );

                    setChildren(enhancedChildren);
                } else {
                    setChildren(children);
                }
                setError(null);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        executeAsync();
    }, [token, webpage_guid]);

    const hasContent = isArrayNotEmpty(children);

    if (loading) {
        return <div className="simplicity-nav-cards-simple-list">Loading...</div>;
    }

    if (error) {
        return <div className="simplicity-nav-cards-simple-error">{error?.message || "An error occurred"}</div>;
    }

    if (!hasContent) {
        return <div className="simplicity-nav-cards-simple-list">This page currently has no navigation cards.</div>;
    }

    return (
        <div className="simplicity-nav-cards-simple-list">
            <div className="simplicity-nav-cards-simple-list-body">
                {children.map((child, index) => (
                    <NavCardsSimpleSectionItem
                        key={index}
                        item={child}
                    />
                ))}
            </div>
        </div>
    );
};

NavCardsSimpleComponent.displayName = "NavCardsSimpleComponent";
export { NavCardsSimpleComponent };
